import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
export function SEO() {
  useEffect(() => {
    // Load Google Analytics script
    const script1 = document.createElement('script');
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-0YS06JE09B';
    script1.async = true;
    document.head.appendChild(script1);
    // Initialize Google Analytics
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-0YS06JE09B');
    `;
    document.head.appendChild(script2);
    // Cleanup
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  return <Helmet data-id="element-273">
      {/* Default meta tags - will be overridden by page-specific ones */}
      <meta property="og:site_name" content="Early Warning Report" data-id="element-274" />
      <meta property="og:type" content="website" data-id="element-275" />
    </Helmet>;
}